export interface AnalyticsUserTraits {
  brand_name: string
  user_id: string
  email: string
  is_internal: boolean
  created_at?: string
  locale_code?: string
  full_name?: string
  verified?: boolean
  org_id?: string
  org_name?: string
  org_role?: string
  has_accounts?: boolean
  has_active_accounts?: boolean
  has_created_budgets?: boolean
  has_budgets?: boolean
  has_created_virtual_cards?: boolean
  has_virtual_cards?: boolean
  subscription_plan_type?: string
  partner_bank?: string
  issuer_banks?: string
  has_active_astrada_card?: boolean
}

export enum AnalyticsPageName {
  AllBudgets = 'All Budgets',
  YourBudgets = 'Your Budgets',
  BudgetHistory = 'Budget History',
  UpdateBudgetFlyout = 'Update Budget Flyout',
  CreateBudgetFlyout = 'Create Budget Flyout',
  RequestBudgetFlyout = 'Request Budget Flyout',
  AccountBudgetList = 'Account Budget List',
  DeactivateBudgetModal = 'Deactivate Budget Modal',
  AllCardsTab = 'All Cards Tab',
  YourCardsTab = 'Your Cards Tab',
  VirtualCardsNeedsApprovalTab = 'Virtual Cards Needs Approval Tab',
  VirtualCardDetail = 'Virtual Card Detail',
  UpdateVirtualCard = 'Update Virtual Card',
  CloseVirtualCard = 'Permanently Close Virtual Card',
  DeactivateVirtualCard = 'Deactivate Virtual Card',
  OrgSettingsExpenseCategoriesTab = 'Org Settings Expense Categories Tab',
  OrgSettingsBusinessRulesTab = 'Org Settings Business Rules Tab',
  OrgSettingsOrganizationInfoTab = 'Organization Info Tab',
  OrgSettingsOrganizationIntegrationsTab = 'Organization Integrations Tab',
  OrgSettingsOrganizationDepartmentsTab = 'Organization Departments Tab',
  DepartmentDetailPage = 'Department Detail Page',
  BillPay = 'bill pay',
  CreateBillPayVirtualCardFlyout = 'create bill pay virtual card flyout',
  UpdateBillPayVirtualCardFlyout = 'update bill pay virtual card flyout',
  VerifyEmailSignUp = 'Verify Email Sign Up',
  BespokeUserSignUp = 'Bespoke User Sign up',
  SyncTransactionModal = 'Sync Transaction Modal',
  BulkEditTransactions = 'bulk edit transactions',

  // TODO finish adding all page names - work with Product on these
  CreateAccount = '/accounts/create',
  YourAccounts = '/accounts/youraccounts',
  AccountOverview = '/accounts/:id/overview',
  AccountVirtualCards = '/accounts/:id/virtualcards',
  AccountTransactions = '/accounts/:id/transactions',
  AccountSettings = '/accounts/:id/settings',
  CloseAccount = '/accounts/:id/settings/close',
  BillPayVirtualCardDetail = '/billpay/:id',
  DeactivateBillPayVirtualCard = '/billpay/:id/deactivate',
  CloseBillPayVirtualCard = '/billpay/:id/close',
  PendingBudgets = '/budgets/pending',
  BudgetsNeedsApproval = '/budgets/needsapproval',
  BudgetOverview = '/budgets/:id/overview',
  BudgetVirtualCards = '/budgets/:id/virtualcards',
  BudgetTransactions = '/budgets/:id/transactions',
  UpdateBudgetRequestFlyout = '/budgetrequests/:id/update',
  Transactions = '/expenses/transactions',
  ExpenseReportCycles = '/expenses/cycles',
  ExpenseReportCycleDetail = '/expenses/cycles/:id',
  UpdateExpenseReportCycleSettings = '/expenses/cycles/:id/update',
  UpdateExpenseReport = '/expenses/cycles/:id/report/:id',
  ExpensesOutOfPocketReports = '/expenses/outofpocket',
  TransactionDetail = '/transactions/:id',
  DownloadTransactions = '/downloadtransactions',
  CreateOrganization = '/orgs/create',
  OrganizationInvitation = '/orgs/invitation/:id',
  OrganizationInviteDecision = '/orginvitedecision',
  RemoveUserFromOrganization = '/orgs/:id/remove',
  UpdateExpenseCategory = '/organizationSettings/:id/expensecategories/:id',
  BulkUploadExpenseLabels = '/organizationSettings/:id/expensecategories/:id/bulkupload',
  OrgSettingsAccountingAutomationTab = '/organizationSettings/:id/rules',
  CreateAccountingAutomationRule = '/organizationSettings/:id/rules/create',
  ManageOrganizationIntegration = '/organizationSettings/:id/integrations/:id/manage',
  OrgSettingsApiKeysTab = '/organizationSettings/:id/apikeys',
  ContactList = '/people/contacts',
  UserDetail = '/people/members/:id',
  MemberList = '/people/members',
  InvitedToOrgList = '/people/invited',
  InvitePeople = '/invite/people',
  CancelInvite = '/people/invited/cancel/:id',
  ProfileInfo = '/profile/info',
  UpdateProfilePhoto = '/profile/photo',
  ManageProfile = '/profile/manage',
  Notifications = '/profile/notifications',
  Security = '/profile/security',
  ChangePassword = '/profile/security/changepassword',
  ManageTrustedDevices = '/profile/security/devices',
  ProfileOverview = '/profile/overview',
  ApiKeys = '/profile/overview/apikeys',
  CreateVirtualCard = '/virtualcards/create',
  RequestVirtualCard = '/virtualcards/request',
  ScreenVirtualCard = '/virtualcards/:id/screen/',
  SignIn = '/signin',
  SignUp = '/signup',
  Onboarding = '/onboarding',
  PricingTiers = 'pricing/tiers',
  ForgotPassword = '/resetpassword',
  Home = '/home',
  Search = '/search',
  WhatsNew = '/whatsnew',
  Help = '/help',
  FAQ = '/faq',
  Terms = '/terms',
  Privacy = '/privacy',
  Support = '/support',
  SupportRequest = '/support-request',
}
